module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av445-61a375c75ac795b4c8e471c0ceda9c30.jpg";